var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 304.542,
    height: 174.396,
    viewBox: "0 0 304.542 174.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.15;}.b{fill:#bbe5f8;}.c{fill:#0b4b7f;}.d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M87.762,0,39.834,54.661H240.259Z",
    transform: "translate(63.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M103.5,21,0,140.734H304.541V21Z",
    transform: "translate(0 33.661)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(124.94 114.528)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M61.074,66.882H66.28v5.206H61.074ZM48,66.882h5.206v5.206H48Zm26.152,0h5.206v5.206H74.152ZM48,55.986h5.206v5.206H48Zm13.074,0H66.28v5.206H61.074Zm13.077,0h5.206v5.206H74.152Zm13.074,0h5.206v5.206H87.226ZM48,44h5.206v5.206H48Zm13.074,0H66.28v5.206H61.074Zm13.077,0h5.206v5.206H74.152Zm13.074,0h5.206v5.206H87.226ZM61.074,77.778H66.28v5.206H61.074ZM48,77.778h5.206v5.206H48Zm26.152,0h5.206v5.206H74.152Zm13.074,0h5.206v5.206H87.226Zm0-10.9h5.206v5.206H87.226Zm39.226,5.448h5.206v5.206h-5.206Zm-13.077,0h5.206v5.206h-5.206Zm26.152,0h5.206v5.206h-5.206Zm13.074,0h5.206v5.206H152.6Zm13.074,0h5.206v5.206h-5.206Z",
    transform: "translate(-48 -44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M88.186,54.884h5.206V60.09H88.186Zm26.152,0h5.206V60.09h-5.206Zm17.432,0h5.206V60.09h-5.206Z",
    transform: "translate(16.415 -26.554)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBackground);
export default __webpack_public_path__ + "static/media/logo-background.5d3979ba45b6cdcfbb58c4829f149c37.svg";
export { ForwardRef as ReactComponent };